"use client";

import { PricingPlan } from "@./suf-store";

import { useSignupFlowStore } from "./useSignUpFlowStore";

/**
 * Returns whether user is in the 7-day trial variant.
 * Only true if discount was successfully applied and planType set to TRIAL_WEEK.
 */
export const useSevenDayTrialTestVariant = () => {
  const planType = useSignupFlowStore((state) => state.subscription.trial?.planType);
  const isTestVariant = planType === PricingPlan.TRIAL_WEEK;

  return {
    isTestVariant,
    planType,
  };
};
